import { default as cnaeBAexy9ClpGMeta } from "/app/pages/admin/cnae.vue?macro=true";
import { default as indexi8nCATZISJMeta } from "/app/pages/admin/index.vue?macro=true";
import { default as organizacoesmfkrBsgnusMeta } from "/app/pages/admin/organizacoes.vue?macro=true";
import { default as profilejkleCjRaDPMeta } from "/app/pages/admin/profile.vue?macro=true";
import { default as usersgSsTxNnO5UMeta } from "/app/pages/admin/users.vue?macro=true";
import { default as contatoBIilrBXvceMeta } from "/app/pages/contato.vue?macro=true";
import { default as docscbEptYMwcSMeta } from "/app/pages/docs.vue?macro=true";
import { default as index4aGTGBC5tJMeta } from "/app/pages/home/index.vue?macro=true";
import { default as profiledohZcwMqFvMeta } from "/app/pages/home/profile.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as login_45legado5Qtj2JIdUyMeta } from "/app/pages/login-legado.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as logoutHaVXWqg8UAMeta } from "/app/pages/logout.vue?macro=true";
import { default as _91id_93KR8N4H3YfPMeta } from "/app/pages/organizacao/[id].vue?macro=true";
import { default as indexpXZfXEUp6KMeta } from "/app/pages/organizacao/index.vue?macro=true";
import { default as _91id_93nCaOySjshNMeta } from "/app/pages/organizacao/status/[id].vue?macro=true";
import { default as _91id_93s2mWvuT5HTMeta } from "/app/pages/organizacao/test/[id].vue?macro=true";
import { default as _91id_93LA9bfIQEqXMeta } from "/app/pages/organizacao/view/[id].vue?macro=true";
import { default as ver_45organizacoestTymiZBNoJMeta } from "/app/pages/ver-organizacoes.vue?macro=true";
export default [
  {
    name: "admin-cnae",
    path: "/admin/cnae",
    component: () => import("/app/pages/admin/cnae.vue").then(m => m.default || m)
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/app/pages/admin/index.vue").then(m => m.default || m)
  },
  {
    name: "admin-organizacoes",
    path: "/admin/organizacoes",
    component: () => import("/app/pages/admin/organizacoes.vue").then(m => m.default || m)
  },
  {
    name: "admin-profile",
    path: "/admin/profile",
    component: () => import("/app/pages/admin/profile.vue").then(m => m.default || m)
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/app/pages/admin/users.vue").then(m => m.default || m)
  },
  {
    name: "contato",
    path: "/contato",
    component: () => import("/app/pages/contato.vue").then(m => m.default || m)
  },
  {
    name: "docs",
    path: "/docs",
    component: () => import("/app/pages/docs.vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    meta: index4aGTGBC5tJMeta || {},
    component: () => import("/app/pages/home/index.vue").then(m => m.default || m)
  },
  {
    name: "home-profile",
    path: "/home/profile",
    component: () => import("/app/pages/home/profile.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login-legado",
    path: "/login-legado",
    meta: login_45legado5Qtj2JIdUyMeta || {},
    component: () => import("/app/pages/login-legado.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: loginhHM0vSTW5jMeta || {},
    component: () => import("/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutHaVXWqg8UAMeta || {},
    component: () => import("/app/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: "organizacao-id",
    path: "/organizacao/:id()",
    component: () => import("/app/pages/organizacao/[id].vue").then(m => m.default || m)
  },
  {
    name: "organizacao",
    path: "/organizacao",
    component: () => import("/app/pages/organizacao/index.vue").then(m => m.default || m)
  },
  {
    name: "organizacao-status-id",
    path: "/organizacao/status/:id()",
    component: () => import("/app/pages/organizacao/status/[id].vue").then(m => m.default || m)
  },
  {
    name: "organizacao-test-id",
    path: "/organizacao/test/:id()",
    component: () => import("/app/pages/organizacao/test/[id].vue").then(m => m.default || m)
  },
  {
    name: "organizacao-view-id",
    path: "/organizacao/view/:id()",
    component: () => import("/app/pages/organizacao/view/[id].vue").then(m => m.default || m)
  },
  {
    name: "ver-organizacoes",
    path: "/ver-organizacoes",
    component: () => import("/app/pages/ver-organizacoes.vue").then(m => m.default || m)
  }
]